import cx from 'classnames';

import InfoIcon from 'components/Icons/Info.svg';

import s from './Item.module.css';

type OverlayProps = {
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const Overlay = ({ className, onClick, ...otherProps }: OverlayProps) => {
  return (
    <div className={cx(s.overlay, className)} {...otherProps}>
      <button className={s.disabledText} onClick={onClick}>
        <span>No matching service providers</span>
        <i className={s.disabledServiceIcon}>
          <InfoIcon />
        </i>
      </button>
    </div>
  );
};

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  className?: string;
  selected?: boolean;
};

const Button = ({ children, className, selected, ...props }: ButtonProps) => {
  return (
    <button
      className={cx(
        s.button,
        {
          [s.selected]: selected,
        },
        className,
      )}
      type="button"
      {...props}
    >
      {children}
    </button>
  );
};

type ItemProps = {
  title: string;
  image?: string;
  listView?: boolean;
  disabled?: boolean;
  selected?: boolean;
  separator?: boolean;
  children: React.ReactNode;
  button: React.ReactNode;
};

const CanvasItem = ({
  title,
  image,
  listView = false,
  disabled = false,
  selected = false,
  separator = false,
  children,
  button,
}: ItemProps) => {
  return (
    <article
      className={cx(s.root, {
        [s.disabled]: disabled,
        [s.listItem]: listView,
        [s.selected]: selected,
      })}
    >
      {image && (
        <div className={s.header} style={{ backgroundImage: `url(${image})` }}>
          <img className={s.image} src={image} alt={title} />
        </div>
      )}

      <div className={s.main}>
        {disabled && <div className={s.disabledOverlay} />}
        <div className={s.description}>
          <h2
            className={cx(s.title, {
              [s.providerSeparator]: separator,
            })}
          >
            {title}
          </h2>
          {button}
        </div>
        <div className={s.details}>{children}</div>
      </div>
    </article>
  );
};

CanvasItem.Button = Button;
CanvasItem.Overlay = Overlay;

export { CanvasItem };
